"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import h from "../helper/helper";
import socketService from "../services/socket.service";
import Observer from "../asset/observer";
import SecuredDataApi, { SecuredData } from "../asset/securedDataWithMetaData";
import Enum from "../asset/enum";
var errors = require("asset/errors");
import * as Bluebird from "bluebird";
import errorService from "../services/error.service";
var initService = require("services/initService");
var THROTTLE = 50;
export var TRUST_SECURED_OPTIONS = {
    type: "trustManager"
};
var TrustStore = /** @class */ (function () {
    function TrustStore(_a) {
        var nicknames = _a.nicknames, ids = _a.ids, me = _a.me, keys = _a.keys, signature = _a.signature;
        var _this = this;
        this.getSignature = function () { return _this.signature; };
        this.update = function (_a) {
            var keys = _a.keys;
            var newKeys = Object.keys(keys)
                .filter(function (key) { return !_this.keys.hasOwnProperty(key); });
            var trustIncreasedKeys = Object.keys(keys)
                .filter(function (key) { return _this.keys.hasOwnProperty(key); })
                .filter(function (key) {
                var oldTrust = unserializeTrust(_this.keys[key].trust);
                var newTrust = unserializeTrust(keys[key].trust);
                return sortedTrustStates.indexOf(oldTrust) < sortedTrustStates.indexOf(newTrust);
            });
            newKeys
                .forEach(function (signKey) { return _this.add(keys[signKey]); });
            trustIncreasedKeys
                .forEach(function (key) { return _this.keys[key].trust = keys[key].trust; });
            if (newKeys.length > 0 || trustIncreasedKeys.length > 0) {
                scheduleTrustmanagerUpload();
            }
        };
        this.add = function (dataSet) {
            var key = dataSet.key, userid = dataSet.userid, nickname = dataSet.nickname;
            var idKey = _this.ids[userid];
            var nicknameKey = _this.nicknames[nickname];
            if (idKey && idKey !== key) {
                throw new errors.SecurityError("we already have got a key for this users id");
            }
            if (nicknameKey && nicknameKey !== key) {
                throw new errors.SecurityError("we already have got a key for this users nickname");
            }
            _this.keys[key] = dataSet;
            if (nickname) {
                _this.nicknames[nickname] = key;
            }
            _this.ids[userid] = key;
        };
        this.get = function (key) { return _this.keys[key]; };
        this.setKeyTrustLevel = function (key, trustLevel) {
            _this.keys[key].trust = trustLevel;
        };
        this.getUpdatedVersion = function () {
            var info = {
                nicknames: _this.nicknames,
                ids: _this.ids,
                me: _this.me
            };
            Object.keys(_this.keys).forEach(function (key) {
                info[key] = _this.keys[key];
            });
            var secured = new SecuredData(null, info, TRUST_SECURED_OPTIONS, true);
            return secured.sign(ownKey);
        };
        this.getTrustSet = function () { return ({
            nicknames: _this.nicknames,
            keys: _this.keys,
            ids: _this.ids,
            me: _this.me,
            signature: _this.signature
        }); };
        this.hasKeyData = function (key) { return _this.keys.hasOwnProperty(key); };
        this.nicknames = nicknames;
        this.ids = ids;
        this.me = me;
        this.keys = keys;
        this.signature = signature;
    }
    return TrustStore;
}());
export { TrustStore };
var trustStore;
var loaded = false;
var fakeKeyExistence = 0;
var ownKey;
var sortedTrustStatesNames = ["BROKEN", "UNTRUSTED", "TIMETRUSTED", "WHISPEERVERIFIED", "NETWORKVERIFIED", "VERIFIED", "OWN"];
export var trustStates = new Enum(sortedTrustStatesNames);
export var transformLegacy = function (_a) {
    var nicknames = _a.nicknames, ids = _a.ids, me = _a.me, _signature = _a._signature, rest = __rest(_a, ["nicknames", "ids", "me", "_signature"]);
    var keys = {};
    Object.keys(rest).filter(function (key) { return h.isRealID(key); }).forEach(function (key) {
        keys[key] = rest[key];
    });
    return {
        nicknames: nicknames,
        ids: ids,
        me: me,
        keys: keys,
        signature: _signature
    };
};
var sortedTrustStates = sortedTrustStatesNames.map(function (trustLevel) {
    return trustStates.fromString("|" + trustLevel + "|");
});
function serializeTrust(trustLevel) {
    return trustStates.toString(trustLevel);
}
function unserializeTrust(trustLevel) {
    return trustStates.fromString(trustLevel);
}
var KeyTrustData = /** @class */ (function () {
    function KeyTrustData(data) {
        var _this = this;
        this.data = data;
        this.getAddedTime = function () { return _this.data.added; };
        this.getKey = function () { return _this.data.key; };
        this.getUserID = function () { return _this.data.userid; };
        this.getNickname = function () { return _this.data.nickname; };
        this.getTrust = function () { return _this.trustSymbol; };
        this.isUntrusted = function () { return _this.trustSymbol === trustStates.UNTRUSTED; };
        this.isTimeTrusted = function () { return _this.trustSymbol === trustStates.TIMETRUSTED; };
        this.isWhispeerVerified = function () { return _this.trustSymbol === trustStates.WHISPEERVERIFIED; };
        this.isNetworkVerified = function () { return _this.trustSymbol === trustStates.NETWORKVERIFIED; };
        this.isVerified = function () { return _this.trustSymbol === trustStates.VERIFIED; };
        this.isOwn = function () { return _this.trustSymbol === trustStates.OWN; };
        this.trustSymbol = unserializeTrust(data.trust);
    }
    return KeyTrustData;
}());
export function userToDataSet(_a, trustLevel) {
    var key = _a.key, userid = _a.userid, nickname = _a.nickname;
    if (trustLevel === void 0) { trustLevel = trustStates.UNTRUSTED; }
    return {
        added: new Date().getTime(),
        trust: serializeTrust(trustLevel),
        key: key,
        userid: userid,
        nickname: nickname
    };
}
var uploadDatabase = function () {
    return initService.awaitLoading()
        .then(function () { return trustStore.getUpdatedVersion(); })
        .then(function (content) { return socketService.emit("trustManager.set", { content: content }); })
        .then(function (response) { return !response.success ? errorService.criticalError(response) : null; });
};
var scheduleTrustmanagerUpload = h.aggregateOnce(THROTTLE, uploadDatabase);
var trustManager = {
    notify: null,
    /*listen: <any> null,*/
    allow: function (count) {
        if (!loaded) {
            fakeKeyExistence = count;
        }
    },
    disallow: function () {
        fakeKeyExistence = 0;
    },
    isLoaded: function () { return loaded; },
    setOwnSignKey: function (_ownKey) {
        ownKey = _ownKey;
    },
    addDataSet: function (dataSet) {
        trustStore.add(dataSet);
    },
    updateDatabase: function (data, cb) {
        if (!loaded) {
            throw new Error("cant update database: not loaded");
        }
        var givenDatabase = SecuredDataApi.load(undefined, data, TRUST_SECURED_OPTIONS);
        return Bluebird.try(function () {
            if (data.me === ownKey) {
                return givenDatabase.verifyAsync(ownKey, "user");
            }
            throw new errors.SecurityError("not my trust database");
        }).then(function () { return trustStore.update(transformLegacy(givenDatabase.metaGet())); }).nodeify(cb);
    },
    hasKeyData: function (keyid) {
        if (!loaded) {
            if (keyid === ownKey) {
                return true;
            }
            else if (fakeKeyExistence > 0) {
                fakeKeyExistence -= 1;
                return true;
            }
            else {
                throw new Error("trust manager not yet loaded");
            }
        }
        return trustStore.hasKeyData(keyid);
    },
    getKeyData: function (keyid) {
        var keyData = trustStore.get(keyid);
        if (keyData) {
            return new KeyTrustData(keyData);
        }
        throw new Error("key not in trust database " + keyid);
    },
    uploadDatabase: uploadDatabase,
    verifyUser: function (user) {
        var signKey = user.getSignKey();
        if (signKey === ownKey) {
            throw new Error("Tried to verify own user.");
        }
        if (trustStore.hasKeyData(signKey)) {
            trustStore.setKeyTrustLevel(signKey, serializeTrust(trustStates.VERIFIED));
        }
        return uploadDatabase();
    },
    addNewUsers: function (userInfo) {
        if (trustManager.isLoaded() && !trustManager.hasKeyData(userInfo.key)) {
            trustManager.addDataSet(userToDataSet(userInfo));
            scheduleTrustmanagerUpload();
        }
    },
    setTrustStore: function (givenTrustStore) {
        if (trustStore) {
            throw new Error("trying to overwrite trust store. Please update instance");
        }
        trustManager.disallow();
        trustStore = givenTrustStore;
        loaded = true;
        trustManager.notify("", "loaded");
    }
};
Observer.extend(trustManager);
socketService.channel("notify.trustManager", function (_e, data) {
    trustManager.updateDatabase(data).catch(errorService.criticalError);
});
export default trustManager;



//////////////////
// WEBPACK FOOTER
// ./js/crypto/trustManager.ts
// module id = 1mek
// module chunks = 1 2 3